export default {
  banner_slogan_line1: '形其未见，成其未来',
  banner_slogan_line2: 'Visualize the Invisible',
  banner_slogan_line3: 'Envision the Future',
  petct_variant: '动物全数字PET/CT',
  header1_home: '首页',
  header1_pet: '动物全数字PET',
  header1_radiation_detection: '全数字辐射探测',
  header1_particle_detector: '粒子探测器',
  header1_plug_n_image: 'Plug-n-Image',
  header1_ip: '创新与知识产权',
  header1_about: '关于RAYCAN',
  header2_product: '产品',
  header2_solution: '解决方案',
  header2_partner: '合作伙伴',
  header2_ip: '创新与知识产权',
  header2_about: '关于RAYCAN',
  header2_happening: '正在发生',
  slogan: '形其未见，成其未来',
  company_intro: '以全球领先的闪烁脉冲数字化方法为核心引擎，开创粒子探测与成像的全新技术范式，构建从探测器到成像系统的全链条解决方案。包括X/γ探测器及成像系统、中子探测器等，推动医学影像、安检安防、高能物理、石油勘探、辐射探测等领域跨越式发展。',
  product_radtarge_mini: '迷你个人计量仪',
  product_radtarge: '个人剂量仪',
  product_radwall: '环境辐射检测仪',
  product_radhfc: '手足沾污仪系列',
  product_basic_detector_module: 'Basic Detector Module',
  product_plug_n_image: 'Plug-n-Image',
  field_oil_exploration: '石油探测',
  field_nuclear_fusion_detection: '核聚变探测',
  field_lightning_detection: '雷电探测',
  honor_global_project: '全球五个项目之一',
  honor_global_project_date: '2022年7月',
  honor_wipo_01: '世界知识产权组织',
  honor_wipo_02: 'WIPO 首届全球奖',
  animal_pet_title: '动物全数字PET',
  trans_pet_name: '高性能动物全数字',
  trans_pet_desc: 'PET/CT系统',
  trans_pet: '高性能动物全数字PET/CT系统',
  core_features: '核心功能',
  feature_dynamic_static_imaging: '动态/静态成像',
  feature_drug_metabolism_monitor: '支持药物代谢动态监测',
  feature_high_resolution_static: '具备高分辨率静态成像能力',
  feature_multi_scenario: '适应多种实验场景的成像需求',
  multimodal_imaging: '多模态成像',
  multimodal_desc1: '实现PET与CT图像的高效融合',
  multimodal_desc2: '结合解剖结构与功能代谢信息',
  multimodal_desc3: '为研究提供更全面的数据基础',
  flexible_expansion: '灵活扩展升级',
  flexible_desc1: '支持轴向与径向FOV双向扩展',
  flexible_desc2: '支持后续快速升级',
  flexible_desc3: '无需更换整机',
  high_throughput: '高通量成像',
  high_throughput_desc1: '支持单次同时对4~8只小鼠或2~4只大鼠进行高清成像',
  high_throughput_desc2: '药物筛选与大样本临床前研究',
  custom_algorithm: '定制算法开发',
  custom_algo_desc1: '结合高性能成像引擎',
  custom_algo_desc2: '支持用户自定义成像算法',
  custom_algo_desc3: '实现亚秒级极速重建',
  offline_data_optimize: '离线数据优化',
  offline_desc1: '基于即插即成像技术',
  offline_desc2: '调整重建与校正参数及算法',
  offline_desc3: '一次扫描，多次成像',
  performance: '性能表现',
  application_areas: '应用领域',
  drug_development: '药物开发',
  pharmacokinetics: '药代动力学',
  pharmacodynamic_eval: '药效评估',
  drug_safety: '药物安全性评估',
  basic_research: '基础科学研究',
  cardiology: '心脏病学',
  oncological_imaging: '肿瘤成像',
  neuroscience: '神经科学（脑成像）',
  immunoimaging: '免疫显像',
  veterinary_medicine: '动物医疗',
  vet_exam: '无误体检',
  tumor_detection: '早期肿瘤发现与鉴别',
  treatment_plan: '辅助确定治疗方案',
  efficacy_eval: '疗效评估',
  application_imaging: '应用成像',
  case_tumor: '肿瘤-评估NO供体给药协同放射治疗的潜力',
  case_colon_cancer: '结肠癌-新型纳米探针结肠癌术前评估、手术引导',
  case_dementia: '痴呆-含巯基的化学物质对血管型痴呆治疗机制研究',
  case_depression: '抑郁-5-羟色胺（5-HT）致重度抑郁症神经回路机制',
  case_myocardial_infarction: '心梗-细胞色素P450 2J2(CYP2J2)可以改善心功能',
  case_ischemic_heart: '缺血性心脏病-PET在缺血性心肌病评估中的应用潜力',
  case_brain_metabolism: '脑代谢-检测脑内葡萄糖的代谢与运输机制',
  case_diabetes: '糖尿病-PET评估肝葡萄糖抑制2型糖尿病机制',
  case_tumor_desc: 'PET显像前，小鼠尾静脉注射200 ± 10 μCi 18FMISO。120 min后，用2%异氟醚麻醉小鼠，置于扫描床上。计算平均和最大SUV。与单纯RT和对照组相比，TPGS-NO和TPGS-NO + RT能显著降低肿瘤组织缺氧水平。',
  case_tumor_ref: 'Jingyao Tu, et al, European Journal of Pharmaceutics and Biopharmaceutics, 2020 (IF=5.589) 武汉同济医院肿瘤科',
  case_colon_cancer_desc: '合成一种基于细胞外囊泡的纳米探针，通过PET/CT和近红外荧光（NIRF）成像来可视化结肠癌，并研究其在图像引导手术中的应用动物模型中的结肠癌。',
  case_colon_cancer_ref: 'Boping Jing, et al., Journal of Nanobiotechnology. 2022 (IF=9.429) 华中科技大学',
  case_dementia_desc: '通过观察模型大鼠脑部FDG-PET成像，观察到ST09显著改善了双侧颈总动脉闭塞(2-VO)诱导血管性痴呆(VaD)模型大鼠不同脑区葡萄糖代谢。',
  case_dementia_ref: 'Liu J, et al. CNS Neuroscience & Therapeutics, 2016 (IF=5.24) 华中科技大学同济医学院药理学系',
  case_depression_desc: '通过PET成像能够了解大鼠大脑内部外侧缰核（LHb）的活度变化。研究揭示了DRN–LHb回路的功能连接及其抗抑郁作用，这可能为抑郁症的治疗提供了一个新的靶点。',
  case_depression_ref: 'Hai Zhang. et al., Brain Structure and Function, 2018(IF=3.748) 华中科技大学同济医学院药理学系',
  case_myocardial_infarction_desc: '利用PET成像技术对心脏进行成像，进一步证明CYP2J2通过增加循环EET的浓度，并通过心肌梗死诱导的心力衰竭中的Jagged1/Notch1信号通路促进血管生成，从而改善心功能。',
  case_myocardial_infarction_ref: 'Qinshuo Z. et al., Journal of Molecular and Cellular Cardiology. 2018 (IF=5.296) 华中科技大学同济医学院附属同济医院心脏病科、内科、高血压研究所',
  case_ischemic_heart_desc: 'PET 成像已被用于心肌血流和碳水化合物代谢的变化。并且这些数据可能对心脏研究产生有益影响。需要进一步的研究来更好地评估 PET 在评估缺血性心脏病方面的潜力。',
  case_ischemic_heart_ref: 'Quan W. et al., American Journal of Cardiovascular Disease. (IF=1.571) 武汉同济医院麻醉与疼痛科',
  case_brain_metabolism_desc: '使用PET成像来检测大脑内葡萄糖的代谢能力。如图2E, F所示, DM大鼠海马区和皮层区葡萄糖转运能力明显受阻。',
  case_brain_metabolism_ref: 'Wang K. et al. Frontiers in Pharmacology. 2019 (IF=5.990) 武汉同济医院中西医结合研究所',
  case_diabetes_desc: '使用PET成像来检测大脑内葡萄糖的代谢能力。如图2E, F所示, DM大鼠海马区和皮层区葡萄糖转运能力明显受阻。在确认HRD对T2DM小鼠的治疗效果后，通过丙酮酸和胰高血糖素耐受试验、肝脏正电子发射断层扫描 (PET) 成像和糖异生关键酶的检测评估HRD对HGP的抑制作用。',
  case_diabetes_ref: 'Fan Wu. et al., Phytomedicine, 2022 (IF=6.656) 华中科技大学同济医学院同济医院中西医结合研究所',
  solutions: '解决方案',
  site_layout: '场地布局方案',
  workstation_1plus1: '1+1配套工作站',
  raypni_platform: 'RayPNI即插即成像软件平台',
  raypni_desc: '本平台旨在实现智能探测与成像系统的灵活部署，支持无缝的端到端数据分析，并加速临床及临床前研究进程。该平台提供覆盖全工作流程的标准化、模块化计算算子与接入协议——从数据采集、图像重建直至数据分析环节皆包含在内。凭借内置的AI辅助功能，用户可定义并调度成像与分析工作流，使PnI智能成像引擎能够作为统一的基础平台发挥作用。该引擎支持探测与成像计算、医学图像分析及临床研究运营，构成了推动重大科学发现与下一代技术突破的核心平台',
  rayplus_platform: 'RayPlus智能医学影像云平台',
  rayplus_desc: '本平台以前瞻性视野构建，围绕开放化、智能化与可扩展三大核心理念设计，将成像计算与数据交互融合于一体化的无缝环境中。该平台采用彻底的原生云架构，深度融合云计算、人工智能与生物信息技术，形成覆盖图像处理、重建、分析与可视化的统一系统。通过轻量化的浏览器/客户端接入模式（B/S），平台突破传统软硬件局限，实现计算资源与算法的统一云端调度。标准化的云接口与软件开发工具包（SDK）支持算法的快速部署与协同工作流构建——为科学研究、临床实践与基层医疗打造高效的数字生态系统',
  radiation_detection: '辐射探测',
  radsys2: 'RadSys 2.0',
  radsys2_desc: '世界首套全数字辐射监测系统',
  radsys: 'RadSys智能辐射管理系统',
  radsys_desc: '通过Zigbee物联网络无线连接个人剂量仪、环境监测仪等设备，组成全方位的辐射监控系统，剂量、时间、位置三位一体精准显示，首次实现了对个人、环境、巡检、废水的综合辐射管理与深度数据分析',
  radwall_fixed: 'RadWall环境定点监测系列',
  radwall_desc: '可精确测量环境空气吸收剂量率(X、γ)，对区域辐射剂量率超阈值报警，避免人员进入辐射危险区域，保障工作环境辐射安全',
  radtarge_series: 'RadTarge个人剂量系列',
  radtarge_title: 'RadTarge 个人剂量系列',
  radtarge_full_desc: 'RadTarge个人剂量仪能够精准探测和显示个人剂量当量(率)数据，对剂量当量率超阈值实时报警能够帮助用户有效的避免非必要的辐射。RadTarge帮助用户建立终身的可追溯的辐射档案，为个性化医疗提供数据支持。企业用户可通过无线通讯连接RadSys智能辐射监测系统管理个人辐射剂量数据，个人用户可通过USB连接RadSuite-Dose管理个人辐射剂量数据。基于自主研发的全数字化SiPM闪烁探测器，在更小的尺寸下获得远优于传统探测器的性能。',
  radtarge_desc: '精准探测和显示个人剂量当量(率)数据，对辐射超阈值实时报警，帮助用户有效避免非必要的辐射',
  radpavise: 'RadPavise环境巡检系列',
  radpavise_title: 'RadPavise 便携式辐射测量仪',
  radpavise_full_desc: 'RadPavise是一款高性能的便携式巡检仪，适用于核医学科、放射科、加速器中心以及核工业以及核应急等应用场景，可以对区域辐射的沾污泄露情况进行巡测，有效的避免工作人员的意外照射。其可以通过外接探头拓展α、β表面沾污测量、中子测量、核素识别等功能，是核应用测量防护的辅助利器。<br/><br/>RadPavise使用了基于高性能的闪烁晶体和光电器件的闪烁探测器，并采用了自主知识产权的MVT技术实现信号数字化，这使得RadPavise实现了很高的灵敏度，可以对微弱的辐射进行响应，同时其内置了宽量程探测器形成双探测器结构，可轻松应对强弱辐射场的使用环境，实现了集高灵敏、宽量程特性于一体的巡检仪。<br/><br/>RadPavise内置了GPS和BLE模块，室外可以使用GPS实现位置、测量值、时间三位一体的测量，室内可以使用BLE定位技术，实现巡测地点的识别。',
  radpavise_desc: '供用户对工作场所辐射水平（X、γ）进行巡检记录，通过外接探头，可扩展实现α、β表面污染测量、中子辐射测量，核素识别等功能，满足多样化的使用需求',
  radwall_mu: 'RadWall-Mu多通道环境辐射监测仪',
  radwall_mu_title: 'RadWall-Mu 多通道环境辐射监测仪',
  radwall_mu_full_desc: 'RadWall-Mu多通道区域环境辐射监测仪采用主机探测器分离结构，主机作为本地处理单元(LPU)显示及处理辐射数据，内嵌了数据库系统，用户可进行实时数据查看、历史数据检索、报告导出至U盘。同时主机拥有独立的用户管理系统，支持管理员、普通用户分级操作权限的管控，便于多用户管理。主机和探头之间使用有线通讯，最多支持外接8通道探头。探头的种类包含X/γ探头、中子探头、废水比活度探头，用户可任意组合实现多种辐射数据的探测与记录。RadWall-Mu还可通过物联网或以太网接入RadSys智能辐射监测系统。',
  radwall_mu_desc: '用于测量放射废液比活度，为环保部门监测废液排放标准提供定量数据支持，有效的避免了危险放射性废液流入环境',
  radhfc_series: 'RadHFC手足沾污仪系列',
  radhfc_title: 'RadHFC 手足沾污仪',
  radhfc_full_desc: 'RadHFC是一款高灵敏的手足表面沾污仪，适用于核医学科、加速器中心、核工业等涉及放射性核素操作的场所，可以快速检测用户双手和双脚是否有放射性沾污，避免放射性污染物带离控制区引起工作人员放射性意外照射，保护身体免受危险的核素内照射伤害。<br/><br/>RadHFC使用了基于高性能的闪烁体和光电器件的闪烁探测器，并采用了自主知识产权的MVT技术实现信号数字化，这使得RadHFC具有很高的灵敏度，可识别微量的核素污染，可同时进行α、β的分离测量。同时设备使用红外传感技术，有效避免设备的二次污染。<br/><br/>RadHFC使用了MySQL数据库进行用户数据管理，保存了历史每一次测量的结果，包含时间、测量值和测量结论，用户可以方便的将数据导出到U盘，进行测量结果管理。',
  radhfc_desc: '适用于核医学科、加速器中心、核工业等涉及放射性核素操作的场所，可以快速检测用户双手和双脚是否有放射性沾污，避免放射性沾污物带离控制区，引起工作人员放射性意外照射，保护身体免受危险的核素内照射伤害',
  radtarge_mini_pro: 'RadTarge-Mini个人剂量仪',
  radtarge_mini_title: 'RadTarge-Mini 迷你个人剂量仪',
  radtarge_mini_full_desc: 'RadTarge-Mini 个人剂量仪能够精准探测和显示个人剂量当量(率)数据，对辐射超阈值实时报警，帮助用户有效避免非必要的辐射。设备使用自主研发的SiPM闪烁探测器，在可穿戴尺寸级别实现了高灵敏探测性能，可检测自然环境的微弱辐射变化，快速响应危险情况。RadMayAPP可实时无线同步显示测量数据，支持用户自定义录制辐射轨迹，变辐射被动记录为主动管理。RadMay为低剂量辐射健康研究提供基础数据，是RAYCAN基于云服务平台的智能辐射管理的重要组成。<br/><br/>RadTarge-Mini用户可以通过蓝牙连接RadMay，建立终身可追溯的个人辐射剂量健康档案，为个性化医疗提供翔实可靠的数据支持。同时结合移动终端的全球定位系统(GPS)可实现精准的时间、位置、剂量率三位一体的剂量测量，绘制全球辐射强度轨迹和分布情况。',
  radtarge_mini_desc: '精准探测和显示个人剂量当量(率)数据，对辐射超阈值实时报警，帮助用户有效避免非必要的辐射',
  solution_ect: 'ECT辐射监测解决方案',
  solution_accelerator: '加速器中心辐射监测解决方案',
  solution_ward: '核素病房辐射监测解决方案',
  application_cases: '应用案例',
  customer_list: '部分客户',
  radsys_full_desc: '通过Zigbee物联网络无线连接个人剂量仪、环境监测仪、核素治疗监测仪等设备，组成全方位的辐射监控系统，剂量、时间、位置三位一体精准显示，首次实现了对个人、环境、巡检、废水、核素治疗的综合辐射管理与深度数据分析。RadSys系统具有远程管理、分级授权、实时监控、多维相应的特点，特别适用于核电、环保以及医疗卫生相关的核医学科、放射科、配药中心、伽马刀治疗中心等场所。同时核素治疗监测仪可实现病人体内残留核素的测量，并可根据法规预测病人出院时间，有效提高病房管理。',
  workstation: '工作站',
  workstation_func: '5大功能，8大模块',
  workstation_db: '无客户端的专业数据库',
  inspection_management: '巡检管理',
  inspection_item: 'α、β监测，环境沾污管理',
  inspection_sync: '无线数据同步，自动报告生成',
  personal_management: '个人管理',
  personal_monitor: '连续监测，无线数据同步',
  personal_analysis: '数据分析，个性化数据库',
  environmental_management: '环境管理',
  env_detector: '多样化探测器，实时报警',
  env_distribution: '辐射分布，可视化数据',
  patient_management: '病人管理',
  patient_monitor: 'α、β监测，环境沾污管理',
  patient_sync: '无线数据同步，自动报告生成',
  wastewater_management: '废水管理',
  wastewater_measure: '比活度测量，定量分析',
  wastewater_control: '连续测量，排放管控',
  comprehensive_management: '全面管理',
  discharge_prediction: '新增核素治疗病人出院预测，优化管理',
  integrated_data: '剂量、时间、位置三位一体',
  multi_platform: '多平台、无客户端设计',
  in_depth_analysis: '深度数据分析',
  engineering_safer_world: 'ENGINEERING A SAFER WORLD',
  env_real_time: '环境辐射实时显示与报警，避免不必要的辐射损伤',
  personal_dose: '个人剂量累计管理与分析，建立个体化终身剂量档案',
  big_data: '辐射大数据平台，帮助人类更好的了解自己和环境',
  radtarge_feature_response: '2秒响应',
  radtarge_feature_accuracy: '精准测量',
  radtarge_feature_analysis: '数据分析',
  radtarge_feature_wearable: '可穿戴式',
  radwall_mu_feature_diverse: '多样化测量',
  radwall_mu_feature_multi_channel: '多通道探测',
  radwall_mu_feature_safety: '安全控制',
  radwall_mu_feature_visual: '可视化数据',
  radpavise_feature_response: '2秒响应',
  radpavise_feature_multi: '多功能探测',
  radpavise_feature_portable: '小巧便携',
  radpavise_feature_ip65: 'IP65',
  radwall_title: 'RadWall 环境辐射监测仪',
  radwall_full_desc: 'RadWall环境辐射监测仪，可精确测量环境空气吸收剂量率(X、γ)，对区域辐射剂量率超阈值报警，避免人员进入辐射危险区域，保障工作环境辐射安全。RadWall帮助用户建立全方位、多样环境的辐射监测网络，为环境辐射安全提供数据支持。通过无线通讯连接RadSys智能辐射监测系统，实现数据自动化记录，可视化显示以及深度的数据分析。RadWall使用内置探测器，可作为本地显示报警单元(ADU)使用，一体化的结构设计，便于安装，易于调整。',
  radwall_feature_response: '2秒响应',
  radwall_feature_accuracy: '精准测量',
  radwall_feature_builtin: '内置探头',
  radwall_feature_plug: '即插即用',
  radhfc_feature_fast: '快速检测',
  radhfc_feature_accuracy: '精准定位',
  radhfc_feature_mixed: '混合测量',
  radhfc_feature_full_scan: '全身扫描',
  radmini_feature_fast: '快速响应',
  radmini_feature_gps: '全球定位',
  radmini_feature_ble: '蓝牙通讯',
  radmini_feature_wearable: '可穿戴式',
  particle_detector: '粒子探测器',
  particle_slogan: '全粒子覆盖，极致解析精度',
  probe: '探头',
  probe_desc: '负责实际探测粒子的核心部件，通常包括各种传感器和探测元件（如光电倍增管、半导体探测器、气体探测器等），用于捕捉粒子的信号并将其转化为可处理的数据',
  interface: '接口',
  interface_desc: '连接不同系统模块或设备的接口部分，负责数据、信号的传输与交换，确保各模块之间的兼容性和通信畅通，常见的接口包括电子信号接口、数据传输接口等',
  digitization: '数字化',
  digitization_desc: '将来自探头组件的模拟信号转换为数字信号的部分，通常包括模数转换器（ADC）和信号处理电路，确保采集到的数据能被计算机或处理单元进一步分析与存储',
  modular_expansion: '模块化扩展',
  modular_desc: '粒子探测器系统的设计方式，允许系统通过标准化模块进行灵活扩展与升级。每个模块独立功能，可以根据实际需求快速增加、替换或优化，提升系统的灵活性与可维护性',
  clock_system: '时钟授时系统',
  clock_desc: '时钟授时系统是为分布式设备提供统一精准时间的技术体系。在核电子领域，其核心作用是为微观物理事件打上纳秒级时间标签，通过精确的时间符合与测量，从海量噪声中准确捕获并还原瞬间发生的核物理过程',
  product_solution: '产品方案',
  industry_challenge: '行业挑战',
  challenge_temp: '175°C高温工作环境',
  challenge_speed: '50ns快速闪烁探测器信号数字化',
  challenge_range: '10MeV宽动态范围数数据采集',
  challenge_density: '1MHz爆发型高密度数据采集',
  oil_gas_instrument: '油气勘探仪器',
  oil_gas_desc: '终结超高温井下传统ADC的采样失效、能谱混叠与数据过载困局，重塑石油饱和度探头的核物理感知极限',
  mvt_solution: 'MVT方案',
  mvt_no_adc: '无需ADC',
  mvt_fpga: '独立FPGA实现采集',
  mvt_wide_range: '宽动态范围',
  advantages: '优势亮点',
  excellent_performance: '性能卓越',
  performance_desc: '借助MVT多阈值采样方法，粒子探测器能够在保证数据轻量化的同时全面采集每个脉冲的波形并进行数字化处理。这一技术突破了时间，能量和位置等多个测量参数的精度限制，大幅提升了探测器的灵敏度和分辨率',
  hardware_agility: '硬件敏捷',
  agility_desc: '通过MVT技术的应用，粒子探测器采用模块化和标准化设计，使得硬件配置与功能扩展更加迅速。每个模块都具有独立功能，能够根据不司需求灵活调整，大大提高了系统的适应性和可维护性',
  customized: '个性化定制',
  custom_desc: '基于MVT方法，粒子探测器通过灵活配置探头、接口、数字化和模块化扩展，根据不同应用需求(如医学、安检、物理实验等)优化性能，提供量身定制的解决方案',
  extreme_env: '极端环境探测',
  extreme_desc: '产品经过严苛环境适配设计，具备宽温工作、抗振动、抗电磁干扰、高防护能力，可在强辐射、高低温、野外现场、工业现场等复杂条件下稳定运行。电源保护、状态监测、冗余设计全面保障系统在恶劣环境中长期可靠工作。',
  plug_n_image: 'Plug-n-Image 即插即成像',
  plug_slogan1: '化繁为简，解放创新',
  plug_desc1: '将复杂的粒子成像系统工程细节，封装为标准模块，并通过直观的界面呈现。让您在上午构思的创新系统，下午即可搭建验证，彻底打破从想法到原型的壁垒',
  plug_slogan2: '流程解耦，激活生态',
  plug_desc2: '数据处理与重建全流程的完全解耦，任何环节的创新算法都能被快速模块化，无缝集成，并即刻获得下游反馈，让算法优化进入高速闭环',
  plug_slogan3: '全栈智能，深度优化',
  plug_desc3: '实现全流程数据留存与AI赋能。在每一个关键环节深度融入人工智能，不仅优化处理效果，更智能调度资源，全面提升研发效率与系统性能',
  plug_architecture: '首创PNI软件架构，从顶层设计上彻底解耦粒子探测与成像全流程，将硬件控制、数据处理、图像重建与校正等底层复杂技术，封装为一系列定义清晰、接口标准的功能模块。在此基础上，构建可供研究者自由组合的创新平台，并深度融合多种异构计算资源，直面皮秒级信号实时处理等极端算力挑战。开启粒子探测与成像领域的图形操作系统时代',
  plug_support_terminal: '支持各种应用场景的一系列用户交互终端',
  plug_support_engine: '支持硬件控制与计算流程自由搭建的智能调度引擎',
  plug_support_protocol: '支持多样化硬件接入的统一硬件控制协议',
  plug_support_library: '支持核心计算能力的探测与成像算法库',
  plug_support_api: '支持人工智能贯穿与优化全流程的开放接口',
  workflow: '工作流程',
  photon_counting_ct: '光子计数CT',
  nuclear_fusion: '核聚变观测',
  neutron_diagnosis: '中子诊断',
  lightning_detect: '雷电探测',
  muon_imaging: '缪子成像',
  large_object: '大物体成像',
  dynamic_process: '动态过程成像',
  neutron_imaging: '中子成像',
  innovation_ip: '创新与知识产权',
  ip_slogan: '不止于创造，更定义未来',
  ip_intro: '以技术研究为基础，以知识产权为助力，全球首创的MVT方法正在赋能创新、影响世界。MVT方法解决了"超高速、超多通道、超宽量程"闪烁脉冲信号精确采样的世界难题，形成一条从理论、技术、部件乃至系统的完整创新链，开创了粒子探测与成像的全新技术范式，正在驱动科学仪器、核辐射探测、石油探测、雷电探测等多个前沿领域的创新加速发展。我们坚信，尊重与保护知识产权是面向未来的必然选择。为此，瑞派宁构建了全球化的知识产权保护体系，并通过技术许可等模式，积极与业界分享发明成果，以此保障创新价值的实现，并持续推动相关行业的技术进步与深刻变革。',
  national_project_1: '国家国际科技合作专项',
  national_project_2: '国家重大科学仪器设备开发专项',
  national_project_3: '国家科技支撑计划',
  national_project_4: '国家重点研发计划数字诊疗专项',
  national_project_5: '国家重点研发计划重大科学仪器设备开发专项',
  national_project_6: '国家重点研发计划政府间国际科技创新合作重点专项',
  national_project_7: '国家重点研发计划科技助力经济2020重点专项',
  national_project_8: '国家重点研发计划基础科研条件与重大科学仪器设备研发专项',
  joint_rd_1: '全数字硅光电倍增器件的联合研发',
  joint_rd_2: '超高分辨率PET的开发和应用',
  joint_rd_3: '高分辨光子病理组织成像系统的研制',
  joint_rd_4: '基于PET光学融合的乳腺成像系统研发',
  joint_rd_5: '小型高灵敏度低能射线纳米尺度三维成像仪器',
  joint_rd_6: '基于全新数字PET技术的阿尔茨海默病脑功能预测模型建立及动态评估',
  joint_rd_7: '小型高灵敏度低能射线细胞病理检测仪',
  joint_rd_8: 'PET/MR双模态成像分析仪的工程化和产业应用示范',
  ip_award_wipo: '世界知识产权组织 WIPO 首届全球奖',
  ip_award_gold: '中国发明专利金奖领域唯一',
  ip_award_demo: '国家知识产权示范企业',
  ip_award_excellence_1: '中国专利奖优秀奖',
  ip_award_excellence_2: '江苏省专利奖优秀奖',
  ip_ratio: '83.7% 发明专利占比',
  ip_coverage: '国家和地区覆盖',
  ip_overseas: '100+ 海外授权专利',
  ip_application: '450+ 专利申请',
  ip_granted: '260+ 授权专利',
  about_raycan: '关于RAYCAN',
  vision: '形其未见，成其未来',
  mission: '为粒子探测与成像领域，提供变革性基石',
  history_2009: '瑞派宁（RAYCAN）正式成立',
  history_2011: '成功研制世界首台商用动物数字PET，标志着数字PET时代的开启',
  history_2012: '推出世界首套全数字辐射监测系统，于中国原子能科学研究院投入运行',
  history_2013: '荣获第41届日内瓦国际发明展金奖',
  history_2014: '研制出基于SiPM的粒子探测器',
  history_2015: '数字PET和粒子探测器被列入"中国制造2025"重点产品规划',
  history_2016: '基于粒子探测器的临床PET原型机成功成像，充分展示了模块化数字化的优越性',
  history_2017_1: '与地中海神经研究所（NEUROMED）共建的联合实验室——数字PET莫里塞研究中心正式成立',
  history_2017_2: '动物数字PET在芬兰国家PET中心装机，成为中国首台进入世界顶尖科研机构的科学仪器',
  history_2018: '粒子探测器在安检领域实现应用',
  history_2020: '粒子探测器在石油探测领域实现应用',
  history_2021: '一种闪烁脉冲的数字化方法（专利号ZL201510003057.1）获得第22届中国专利奖金奖',
  history_2022: '荣获世界知识产权组织（WIPO）首届全球奖、国家知识产权示范企业',
  history_2023: '粒子探测器进一步在人造卫星领域实现应用',
  history_2024: '作为重要参与单位，助力制定中国的数字PET标准',
  national_project_title: '国家项目',
  recruit_intro: '我们寻找的不是按部就班的执行者，而是渴望亲手塑造事物、推动改变的同路人。在这里，每一行代码、每一个方案、每一次探讨，都可能直接触及成千上万用户的真实需求。我们相信，最好的创新并非源于孤独的天才，而是来自多元背景的碰撞——无论你擅长缜密的逻辑构建、敏锐的用户洞察，还是天马行空的创意表达，你的独特视角都将被珍视。',
  job_hardware_engineer: '硬件工程师',
  job_software_engineer: '软件工程师',
  job_responsibility: '岗位职责',
  job_requirement: '任职条件',
  company_name: '苏州瑞派宁科技有限公司',
  work_location: '合肥科大',
  banner_slide1_title: '辐射监测产品',
  banner_slide2_title: '动物全数字PET/CT',
  banner_slide3_title: '探测器技术',
  detector_xray: 'X射线探测器',
  detector_neutrino: '中微子探测器',
  detector_electron: '电子/正电子探测器',
  radwall_fixed_short: '环境定点监测系列',
  radsys_short: '智能辐射管理系统',
  radtarge_series_short: '个人剂量系列',
  radpavise_short: '环境巡检系列',
  radwall_mu_short: '多通道环境辐射监测仪',
  radtarge_mini_short: '个人剂量仪',
  petct_variant: '动物全数字PET/CT',
  solution_ect_short: 'ECT辐射监测',
  solution_accelerator_short: '加速器中心辐射',
  solution_ward_short: 'PET/CT辐射',
  solution_monitoring: '监测解决方案',
  solution_petct_short: '监测解决方案',
  footer_address: '中国江苏省苏州市高新区锦峰路8号17栋',
  footer_phone: '0512-62391918',
  footer_icp: '苏ICP备 12056660 号',
  footer_security: '江苏公网安备 32050502000347 号',
  ip_ratio: '83.7% 发明专利占比',
  ip_coverage: '27个 国家和地区覆盖',
  ip_overseas: '100+ 海外授权专利',
  about_join_us: '加入我们',
  radsys_short_desc: '智能辐射管理系统',
  workstation_short: '工作站',
  workstation_func_short: '5大功能，8大模块',
  workstation_db_short: '无客户端的专业数据库',
  radsys_module_inspection: '巡检管理',
  radsys_module_personal: '个人管理',
  radsys_module_env: '环境管理',
  radsys_module_patient: '病人管理',
  radsys_module_wastewater: '废水管理',
  radsys_module_comprehensive: '全面管理',
  radsys_feature_discharge: '新增核素治疗病人出院预测，优化管理',
  radsys_feature_integrated: '剂量、时间、位置三位一体',
  radsys_feature_multi_platform: '多平台、无客户端设计',
  radsys_feature_analysis: '深度数据分析',
  radsys_module_inspection_item: 'α、β监测，环境沾污管理',
  radsys_module_inspection_sync: '无线数据同步，自动报告生成',
  radsys_module_personal_monitor: '连续监测，无线数据同步',
  radsys_module_personal_analysis: '数据分析，个性化数据库',
  radsys_module_env_detector: '多样化探测器，实时报警',
  radsys_module_env_distribution: '辐射分布，可视化数据',
  radsys_module_patient_monitor: 'α、β监测，环境沾污管理',
  radsys_module_patient_sync: '无线数据同步，自动报告生成',
  radsys_module_wastewater_measure: '比活度测量，定量分析',
  radsys_module_wastewater_control: '连续测量，排放管控',
  radsys_full_desc: '通过Zigbee物联网络无线连接个人剂量仪、环境监测仪、核素治疗监测仪等设备，组成全方位的辐射监控系统，剂量、时间、位置三位一体精准显示，首次实现了对个人、环境、巡检、废水、核素治疗的综合辐射管理与深度数据分析。RadSys系统具有远程管理、分级授权、实时监控、多维相应的特点，特别适用于核电、环保以及医疗卫生相关的核医学科、放射科、配药中心、伽马刀治疗中心等场所。同时核素治疗监测仪可实现病人体内残留核素的测量，并可根据法规预测病人出院时间，有效提高病房管理。',
  workstation: '工作站',
  workstation_func: '5大功能，8大模块',
  workstation_db: '无客户端的专业数据库',
  comprehensive_management: '全面管理',
  discharge_prediction: '新增核素治疗病人出院预测，优化管理',
  integrated_data: '剂量、时间、位置三位一体',
  personal_monitor: '连续监测，无线数据同步',
  personal_analysis: '数据分析，个性化数据库',
  inspection_item: 'α、β监测，环境沾污管理',
  inspection_sync: '无线数据同步，自动报告生成',
  component_store: '全域组件',
  pet_ctr: 'PET中CTR',
  pet_ctr_desc: '用于区分一对符合光子的到达时间差， CTR 越小，TOF 定位越准，成像信噪比越高',
  pet_er: 'PET中ER',
  pet_er_desc: '用于精准识别特征峰、抑制康普顿噪声，有效剔除散射事件，提升成像纯度与精度',
  mvt_core_advantages: 'MVT核心优势',
  mvt_advantages_desc: '灵活架构选型、高速脉冲采集、1:1:1 真全读出架构',
  case_one: '案例一',
  case_two: '案例二',
  case_one_title: '数字PET探测器',
  case_one_challenge_digitization: '源头数字化',
  case_one_challenge_sensitivity: '高灵敏度',
  case_one_challenge_time_resolution: '高时间分辨率',
  case_one_challenge_spatial_resolution: '高空间分辨率',
  case_one_pet_detector_desc: '数字PET探测器能够实现高灵敏度和稳定的信号输出。',
  case_one_er_desc: '能量分辨率：用于精准识别特征峰、抑制康普顿噪声，有效剔除散射事件，提升成像纯度与精度。',
  case_one_ctr_desc: '时间分辨率：用于区分一对符合光子的到达时间差，CTR 越小，TOF 定位越准，成像信噪比越高。',
  case_one_mvt_flexible: '灵活架构选型',
  case_one_mvt_high_speed: '高速脉冲采集',
  case_one_mvt_full_readout: '1:1:1 真全读出架构',
  case_two: '案例二',
  excellent_performance_new: '性能卓越',
  performance_desc_new: '采用高精度 MVT 数字化架构与低噪声前端设计，实现超高时间分辨率、优异能量分辨率与稳定脉冲采集，可精准捕捉微弱核辐射信号。系统具备高计数率承受能力、低纹波与低干扰特性，在高能物理、PET 成像、辐射检测等场景中保持高灵敏度、高可靠性与高测量精度。',
  hardware_agility_new: '硬件敏捷',
  agility_desc_new: '采用标准化、模块化硬件架构，功能单元即插即用，信号链路解耦设计，支持快速搭建、快速调试与快速部署。从单通道到大规模阵列均可灵活组合，大幅缩短系统集成周期，满足科研实验与工业检测快速迭代、快速验证的需求。',
  customized_new: '个性化定制',
  custom_desc_new: '支持通道数量、阈值配置、接口协议、采样参数等深度定制，可根据探头类型、探测目标与使用场景量身优化。提供芯片、板卡、阵列系统三级定制能力，兼顾专用设备开发、科研装置改造、大型探测系统集成等多样化需求。',
  job_resp_1: '1.负责辐射探测器和小动物PET/CT/MR/SPECT等产品的硬件研发工作，包括元器件选型、硬件电路设计、PCB设计开发、EMC设计，以及对单板和整机硬件进行调试、问题解决和整改等；',
  job_resp_2: '2.根据系统需求，制定硬件设计方案，确定硬件关键指标性能，保障技术方案落地；',
  job_resp_3: '3.负责硬件技术方案评审，与软件、算法、机械、探测器、系统集成、嵌入式、测试、生产等相关工程师合作，定位解决硬件问题；',
  job_resp_4: '4.参与样机的装配及调试，以及产品试产及完善过程，支持辐射探测产品和影像产品的检定工作及安规工作。',
  job_resp_5: '',
  job_resp_6: '',
  job_req_1: '1.本科及以上学历，电子工程、电气工程、微电子、自动化、光电等专业；具备3-5年或以上硬件设计研发经验，有医疗影像设备、放射治疗设备、辐射探测等领域相关经验者优先；',
  job_req_2: '2.熟练掌握模拟电路和数字电路的设计，熟练掌握硬件常用有线及无线通信协议，有电源电路设计经验者优先；熟练掌握EDA软件（如AD/Cadence/Allegro），能够独立完成硬件原理图设计及PCB layout设计；',
  job_req_3: '3.熟练掌握板级电路调试、驱动调试，具备快速识别和解决故障的能力；',
  job_req_4: '4.熟练掌握EMC、信号完整性等相关知识，支持产品检定及安规工作；',
  job_req_4a: '5.具有整机产品从立项到交付的全流程硬件研发经验者优先；',
  job_req_4b: '6.英语优秀，具有较强的听说读写能力者优先；',
  job_req_4c: '7.有高度的责任感，主动，追求卓越；',
  job_req_4d: '8.具有良好的沟通协调能力与团队合作精神。',
  job_req_4e: '',
  job_company_info: '入职公司：苏州瑞派宁科技有限公司',
  job_work_location: 'HR邮箱：yueqing.wang@ray-can.com',
}